import React from 'react';
import PropTypes from 'prop-types';

import WYSIWYG from 'components/WYSIWYG';
import LegacyAnswers from './LegacyAnswers';
import LegacyExplanation from './LegacyExplanation';

export const LegacySingleChoiceQuestion = ({
  showResponseCorrectness = false, canShowAnswer = false, selectedAnswer = null, onChangeAnswer = () => {}, onClickShowAnswer = () => {}, onClickAnswer = () => {}, peerComparisonPercents, disableAnswerSelection, question
}) => {
  const renderShowAnswerButton = () => (
    <button
      className="question-see-answer-btn btn btn-primary"
      type="button"
      onClick={() => onClickShowAnswer()}
    >
      See Answer
    </button>
  );

  return (
    <div className="LegacyQuestion SingleChoiceQuestion">
      <WYSIWYG
        className="question-name"
      >
        { question.safe_name }
      </WYSIWYG>
      <LegacyAnswers
        answers={question.answers}
        onSelectAnswer={answerId => onChangeAnswer(answerId)}
        onClickAnswer={(ev, answerId, isSelected) => onClickAnswer(ev, answerId, isSelected)}
        selectedAnswerIds={selectedAnswer || []}
        correctAnswerIds={question.correct_answer_ids}
        showResponseCorrectness={showResponseCorrectness}
        disableAnswerSelection={disableAnswerSelection}
      />
      { canShowAnswer && (showResponseCorrectness ? (
        <LegacyExplanation question={question} peerComparisonPercents={peerComparisonPercents} />
      ) : renderShowAnswerButton()) }
    </div>
  );
};


LegacySingleChoiceQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  showResponseCorrectness: PropTypes.bool,
  canShowAnswer: PropTypes.bool,
  selectedAnswer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number)
  ]),
  onChangeAnswer: PropTypes.func,
  onClickShowAnswer: PropTypes.func,
  onClickAnswer: PropTypes.func,
  peerComparisonPercents: PropTypes.object,
  disableAnswerSelection: PropTypes.bool
};

export default LegacySingleChoiceQuestion;
